var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "button",
      {
        staticClass: "btn btn-xs btn-default mb-1",
        attrs: { type: "button" },
        on: { click: _vm.addNewRecord },
      },
      [_vm._v("Добавить запись")]
    ),
    _vm._v(" "),
    _c("table", { staticClass: "table table-sm m-0" }, [
      _c(
        "tbody",
        _vm._l(_vm.records, function (rds, countryId) {
          return ["supplier_data", "country_data"].includes(rds.group_alias) &&
            rds.alias === "title"
            ? _c("tr", [
                _c("td", [
                  _c(
                    "select",
                    {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: rds.group_alias,
                          expression: "rds.group_alias",
                        },
                      ],
                      staticClass: "form-control",
                      attrs: { disabled: rds.to_delete },
                      on: {
                        change: [
                          function ($event) {
                            var $$selectedVal = Array.prototype.filter
                              .call($event.target.options, function (o) {
                                return o.selected
                              })
                              .map(function (o) {
                                var val = "_value" in o ? o._value : o.value
                                return val
                              })
                            _vm.$set(
                              rds,
                              "group_alias",
                              $event.target.multiple
                                ? $$selectedVal
                                : $$selectedVal[0]
                            )
                          },
                          function ($event) {
                            return _vm.updateType(rds)
                          },
                        ],
                      },
                    },
                    [
                      _c("option", { attrs: { value: "supplier_data" } }, [
                        _vm._v("поставщик"),
                      ]),
                      _vm._v(" "),
                      _c("option", { attrs: { value: "country_data" } }, [
                        _vm._v("страна"),
                      ]),
                    ]
                  ),
                ]),
                _vm._v(" "),
                _c("td", [
                  _c(
                    "select",
                    {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: rds.int_value,
                          expression: "rds.int_value",
                        },
                      ],
                      staticClass: "form-control",
                      attrs: { disabled: rds.to_delete },
                      on: {
                        change: function ($event) {
                          var $$selectedVal = Array.prototype.filter
                            .call($event.target.options, function (o) {
                              return o.selected
                            })
                            .map(function (o) {
                              var val = "_value" in o ? o._value : o.value
                              return val
                            })
                          _vm.$set(
                            rds,
                            "int_value",
                            $event.target.multiple
                              ? $$selectedVal
                              : $$selectedVal[0]
                          )
                        },
                      },
                    },
                    [
                      rds.group_alias === "country_data"
                        ? [
                            _c("option", { domProps: { value: 0 } }, [
                              _vm._v("любая страна"),
                            ]),
                            _vm._v(" "),
                            _vm._l(_vm.$AllCountries, function (c) {
                              return _c(
                                "option",
                                { domProps: { value: c.id } },
                                [_vm._v(_vm._s(c.name))]
                              )
                            }),
                          ]
                        : [
                            _c("option", { domProps: { value: 0 } }, [
                              _vm._v("любой поставщик"),
                            ]),
                            _vm._v(" "),
                            _vm._l(_vm.suppliers, function (c) {
                              return _c(
                                "option",
                                { domProps: { value: c.id } },
                                [_vm._v(_vm._s(c.title))]
                              )
                            }),
                          ],
                    ],
                    2
                  ),
                ]),
                _vm._v(" "),
                _c("td", [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: rds.text_value,
                        expression: "rds.text_value",
                      },
                    ],
                    staticClass: "form-control",
                    attrs: {
                      type: "text",
                      placeholder: "Наименование",
                      disabled: rds.to_delete,
                    },
                    domProps: { value: rds.text_value },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.$set(rds, "text_value", $event.target.value)
                      },
                    },
                  }),
                ]),
                _vm._v(" "),
                _c("td", [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-default",
                      attrs: { type: "button" },
                      on: {
                        click: function ($event) {
                          rds.to_delete = !rds.to_delete
                        },
                      },
                    },
                    [_c("i", { staticClass: "icon-fa icon-fa-remove" })]
                  ),
                ]),
              ])
            : _vm._e()
        }),
        0
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }